var app = {
	templateUrl: './app.html',
	controller: 'AppController',
	controllerAs: 'vm'
};

angular
	.module('common')
	.component('app', app)
	.config(function ($stateProvider) {
		$stateProvider
			.state('app', {
				redirectTo: 'inicial',
				url: '/app',
				component: 'app'
			})
	});
